import { render, staticRenderFns } from "./RutePenyebranganUpload.vue?vue&type=template&id=19896436&scoped=true"
import script from "./RutePenyebranganUpload.vue?vue&type=script&lang=js"
export * from "./RutePenyebranganUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19896436",
  null
  
)

export default component.exports